<template>
    <div :class="balaoClass" v-if="mostrarFeedBack" v-html="mensagemFeedBack(mensagem.feedback)">
    </div>
    <!-- TODO verificar necessidade  -->
    <div v-if="mostrarMensagem" :class="balaoClass" ref="balao">
        <div v-if="!mensagem.link"  v-html="mensagem.texto"></div>
        <div v-else-if="mensagem.link" v-html="link(mensagem)"></div>
    </div>

    <!-- Resposta  -->
    <div v-if="mostrarResposta" :class="balaoClass" ref="balao">
        <div v-if="!mensagem.link">{{ mensagem.texto }}</div>
        <div v-else-if="mensagem.link" v-html="link(mensagem)"></div>
    </div>

    <div :class="balaoClass" ref="balao" v-for="(mensagem, i) in mensagem.html" :key="i">
      <div v-if="mostrarHtml" v-html="mensagem.titulo + mensagem.corpoDocumento">
      </div>
    </div>

    <div v-if="mostrarConfirmacao" :class="balaoClass" ref="balao">
        <div>{{ mensagem.resposta.pergunta }}</div>
    </div>

    <div v-if="mostrarConfirmacao" class="balao_de_conversa_opcoes" ref="balao">
        <div v-for="(op, i) in mensagem.opcoes" class="opcoes" :key="op.value" @click="onRespond(op,mensagem)">
            <span class="numeroOpcao">{{ i + 1 }}</span> {{ op.texto }}
        </div>
    </div>

    <!-- Intermediario  -->

    <div v-if="mostrarOpcoes" :class="balaoClass" ref="balao">
        <div>{{ mensagem.resposta.pergunta }}</div>
    </div>

    <div v-if="mostrarOpcoes" class="balao_de_conversa_opcoes" ref="balao">
        <div v-for="(op, i) in mensagem.opcoes" class="opcoes" :key="op.value" @click="onRespond(op,mensagem)">
            <span class="numeroOpcao">{{ i + 1 }}</span> {{ op.texto }}
        </div>
    </div>

    <!-- Pergunta e Resposta  -->
    <div v-if="mostrarPergunta" :class="balaoClass" ref="balao">
        <div>
            {{ mensagem.resposta.pergunta }}
            <div v-if="mensagem.resposta.tipo === 'SELECT'">
                <select
                    id="inputlocalidade"
                    class="form-control select_option"
                    required
                    @change="selectAction($event)"
                >
                    <option selected disabled value="">Escolha a opcao</option>
                    <option
                        v-for="(option, index) in mensagem.resposta.opcoes"
                        :value="option.value"
                        :key="index"
                    >
                        {{ option.label }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <!-- Usuario  -->
    <div v-else-if="mensagem.isUser" :class="balaoClass" ref="balao">
        <div class="balao_de_conversa_direito">{{ mensagem.texto }}</div>
    </div>

    <!-- Loader  -->
    <div class="balao_de_conversa_esquerdo" v-if="mensagem.tipo === 'loader'" ref="balao">
        <div class="loader_bot">{{ mensagem.texto }}</div>
    </div>
</template>
<script>
import BotMachine from './BotMachine';
// import EscolherInteracao from './components/EscolherInteracao.vue';
export default {
    name: "BotMensagem",
    // components: {
    //     'escolherInteracao': EscolherInteracao
    // },
    props: {
        mensagem: {
            type: Object,
            required: true,
        }
    },
    setup() {
        return {
            tiposInteracao: BotMachine.tiposInteracao
        }
    },
    data() {
        return {
            interacoesRealizadas: [],
            componentes: [

            ]
        }
    },
    mounted() {
        this.rolagemAutomatica();
    },
    updated() {
        if(!this.$refs){
        this.rolagemAutomatica();
        }
    },
    methods: {
        onRespond(op,mensagem) {
            if (!this.interacoesRealizadas.includes(mensagem)) {
            var data = mensagem.resposta.data ? mensagem.resposta.data : null;
            op.data = data;
            this.$emit('resposta', op)
            this.interacoesRealizadas.push(mensagem);
            }
        },
        rolagemAutomatica() {
            this.$refs.balao.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' }); // utilizando a ref de container, uso a função scrollIntoView para rolagem automatica.
           
        },
        // onOptionClick(op) {
        //     if (!op.disabled) {
        //         op.disabled = true;
        //         this.$emit('resposta', op);
        //     }
        // },
        link(mensagem) {
            const html = `<a href = '${mensagem.link}' target='_blank'>Clique Aqui</a>`;
            return mensagem.texto.replace("$link", html);
        },
        mensagemFeedBack(feedback) {
            return feedback.replace(this.mensagem.texto, `<strong>${this.mensagem.texto}</strong>`);
        },
        selectAction(event) {
            this.$emit("input", event.target.value);
        },
    },
    computed: {
        balaoClass() {
            return !this.mensagem.isUser ? "balao_de_conversa_esquerdo" : "balao"
        },
        mostrarOpcoes() {
            const opcoes = this.mensagem.opcoes
            return !!opcoes && this.mensagem.tipo === this.tiposInteracao.intermediario;
        },
        mostrarMensagemIntermediaria() {
            return this.mensagem.tipo === this.tiposInteracao.intermediario;
        },
        mostrarMensagem() {
            return this.mensagem.tipo === this.tiposInteracao.final || this.mensagem.tipo === this.tiposInteracao.restart // TODO revisar necessidade
        },
        mostrarResposta() {
            return this.mensagem.tipo === this.tiposInteracao.resposta && this.mensagem.texto !== null;
        },
        mostrarConfirmacao() {
            const opcoes = this.mensagem.opcoes
            return !!opcoes && this.mensagem.tipo === this.tiposInteracao.resposta
        },
        mostrarPergunta() {
            return this.mensagem.tipo === this.tiposInteracao.perguntaResposta;
        },
        mostrarFeedBack() {
            return (this.mostrarMensagemIntermediaria || (this.mostrarPergunta && this.mensagem.feedback !== null) || (this.mostrarConfirmacao && this.mensagem.feedback !== null));
        },
        mostrarHtml() {
            return this.mensagem.tipo === this.tiposInteracao.resposta
        }
    }
}
</script>
<style>
.opcoes {
    letter-spacing: 0px;
    color: #707070;
    opacity: 1;
    font: normal normal normal 16px/18px Raleway;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px #7070704D solid;
}

.numeroOpcao {
    margin: 10px;
    width: 7px;
    height: 27px;
    font: normal normal 800 18px/18px Raleway;
    letter-spacing: 0px;
    color: #2955A2;
    opacity: 1;
}
</style>